export default class ChooseSize {
    constructor({selector}) {
        if (!selector) return

        this.wrapper = selector;
        this.sizeElems = this.wrapper.querySelectorAll('.js-size-row');
        this.addToCartBtn = this.wrapper.closest('.product-size-block--b2c') ? this.wrapper.closest('.product-size-block--b2c').querySelector('.add-to-cart') : null;

        this.eventListeners();
        this.disabledAddToCartBtn();
    }

    eventListeners() {
        this.wrapper.addEventListener('click', (e)=> {
            if(e.target.closest('.js-size-row')) {
                this.chooseSize(e);
                this.changeFinalPriceInInfoRow(e);
            }
        });
    }

    chooseSize(e) {
        if(this.sizeElems.length > 0) {
            this.sizeElems.forEach(elem => {
                elem.classList.remove('offer-wr--selected');
            })
        }

        e.target.closest('.js-size-row').classList.add('offer-wr--selected');
        const addToCartBtn = e.target.closest('.product-size-block--b2c').querySelector('.add-to-cart');

        if(addToCartBtn) {
            addToCartBtn.classList.remove('btn-default');
        }
    }

    disabledAddToCartBtn() {
        this.addToCartBtn ? this.addToCartBtn.classList.remove('in-basket') : null;
    }

    /**
     * при клике на размер в b2c подставляем в итоговую цену окончательную розничную цену товара
     * (актуально для товаров больших размеров, цена на которые выше стандартной)
     * @param e
     */
    changeFinalPriceInInfoRow(e) {
        const finalPriceElement = e.target.closest('.info-product-wr').querySelector('.price-wr--with-lock-btn .price-block .price');
        const finalPriceValue = e.target.closest('.js-size-row') ? e.target.closest('.js-size-row').dataset.formatPrice : null;

        if(finalPriceElement && finalPriceValue) {
            let price = parseInt(finalPriceValue.replace(/[^0-9]/g, ''));
            finalPriceElement.innerText = price.toLocaleString() + ' ₽';
        }
    }
}